import { useState } from 'react'
import { useView } from '@10000/react'
import { AddPill, AdminDialog, Body, Box, Input, UserPill } from '../../widgets'
import { SettingsLayout } from '../'
import { User } from './'
import './Users.scss'

export const Users = ({ superUserMode, goBackToSettingsMenu }) => {
  const { users, user } = useView('tenant')
  const admin = superUserMode || user?.admin

  const [search, setSearch] = useState('')
  const [selectedUser, setSelectedUser] = useState()

  const [createUserOpen, setCreateUserOpen] = useState(false)

  const [showAdmins, setAdmins] = useState(false)
  const [showTeamLeads, setTeamLeads] = useState(false)

  const setFilter = (admins, leads) => {
    setAdmins(admins)
    setTeamLeads(leads)
  }

  const searchMatches = attribute => attribute?.toLowerCase().includes(search.toLowerCase())

  const filteredUsers = users.filter(user =>
    (!search || (searchMatches(user?.name) || searchMatches(user.email)))
    && ((!showAdmins && !showTeamLeads) || (showAdmins && user?.admin) || (showTeamLeads && !user?.admin))
  )

  return (
    selectedUser === undefined
      ? <SettingsLayout
          gap={16}
          title="Users"
          onBackButtonClick={goBackToSettingsMenu}
          backButtonMobileOnly
        >
          <Input dark leftIcon="Search" value={search} onChange={(e) => setSearch(e.target.value)}/>
          <Box gap={8} fullWidth>
            <Box
              className={`filter${(!showAdmins && !showTeamLeads) ? ' white' : ' black'}`}
              onClick={() => setFilter(false, false)}
            >
              <Body bold alt>All</Body>
            </Box>
            <Box
              className={`filter${showAdmins ? ' white' : ' black'}`}
              onClick={() => setFilter(true, false)}
            >
              <Body bold alt>Admins</Body>
            </Box>
            <Box
              className={`filter${showTeamLeads ? ' white' : ' black'}`}
              onClick={() => setFilter(false, true)}
            >
              <Body bold alt noWrap>Team Leaders</Body>
            </Box>
          </Box>
          <Box column gap={16} fullWidth pb={16}>
            {filteredUsers.map((user, index) =>
              <UserPill
                key={index}
                user={user}
                action={!user?.onboard}
                invited
                actionText="Edit"
                onClick={() => setSelectedUser(user.id)}
                blackListBackgrounds={['white']}
              />
            )}
            {admin && <AddPill text="Add admin" onClick={() => setCreateUserOpen(true)}/>}
          </Box>

          <AdminDialog open={createUserOpen} onClose={() => setCreateUserOpen(false)}/>
        </SettingsLayout>
      : <User selectedUser={selectedUser} onClose={() => setSelectedUser(undefined)} />
  )
}